import React, { memo } from "react";
import {
	Route,
	RouteProps,
	Redirect,
	RouteComponentProps
} from "react-router-dom";
import FallBackLoading from "../../containers/FallBackLoading";

type Props = Omit<RouteProps, "component"> & {
	isAuthenticated: "pending" | "logged" | "notLogged";
	isAuthPage?: boolean;
	redirectTo: string;
	component:
		| React.ComponentType<RouteComponentProps<any>>
		| React.ComponentType<any>;
};

function PrivateRouteRaw({
	component: Component,
	isAuthenticated,
	redirectTo,
	isAuthPage,
	...rest
}: Props) {
	return (
		<Route
			{...rest}
			render={props => {
				if (
					(isAuthenticated === "logged" && isAuthPage) ||
					(isAuthenticated === "notLogged" && !isAuthPage)
				) {
					return <Component {...props} />;
				} else if (isAuthenticated === "pending") {
					return <FallBackLoading />;
				} else {
					return (
						<Redirect
							to={`${redirectTo}?path=${window.location.pathname}`}
						/>
					);
				}
			}}
		/>
	);
}

export const PrivateRoute = memo(PrivateRouteRaw);
